import { PHONE_DIAL_CODES } from "../phoneDialCodes";

/** Shared RSuite control props — matches admin modals (AllowedAddressModal, etc.) */
export const ORDER_FORM_FIELD_PROPS = {
  block: true,
  size: "lg" as const,
  appearance: "subtle" as const,
};

export const PHONE_DIAL_CODE_PICKER_DATA = PHONE_DIAL_CODES.map((item) => ({
  label: item.label,
  value: item.pickerValue,
}));
